import dynamic from 'next/dynamic';

import HeadSEO from 'components/base/headSEO';
import Layout from 'components/layout';
import MyAccountLayout from 'components/layout/myaccount';
import { initCMS } from 'utils/cms';
import { IS_NNORMAL } from 'utils/constants/system';

// en teoria no hace falta, pero puede que camperlab si tenga esta ruta.
const CamperWelcome = dynamic(() => import('components/myAccount/camperWelcome').then((mod) => mod.CamperWelcome));

export async function getServerSideProps(context) {
  const { locale } = context;
  if (IS_NNORMAL) {
    return {
      redirect: {
        destination: `/${locale}/myaccount/nnormal-world`,
        permanent: false,
      },
    };
  }
  const { defaultProps } = await initCMS({ context, locale });

  const gtmProps = { url: context?.req?.url };

  return {
    props: {
      defaultProps,
      gtmProps,
    },
  };
}

function Account({ defaultProps, gtmProps }) {
  return (
    <Layout {...defaultProps} breadcrumbs={false}>
      <HeadSEO description="Your order" pageName={'Account'} gtmProps={gtmProps} />
      <MyAccountLayout withCategoriesLayout={false}>
        <CamperWelcome />
      </MyAccountLayout>
    </Layout>
  );
}

Account.i18nPage = 'Account';

export default Account;
